<template>
  <div>
    <banner />
    <div class="home">
      <div class="zd-warp">
        <div class="w-flex">
          <span class="title">
            <span class="t-text">物联网整体解决方案</span>
            <span class="t-bg"></span>
          </span>
          <div class="subText">Overall solution for the lnternet of Things</div>
        </div>
        <div class="w-content w1100">
          <el-row :gutter="10">
            
            <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
              <div class="image-text height" @click="toRouterName('WifiNetwork')">
                <span class="title">WIFI无线网络解决方案</span>
                <span class="btn-text">了解更多</span>
              </div>
            </el-col>
            <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
              <div class="img-box height">
                <img src="@/assets/home/p1wifi.png" class="images" alt="" />
              </div>
            </el-col>
            <!-- <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
              <div class="img-box height">
                <img src="@/assets/home/shuye.png" class="images" alt="" />
              </div>
            </el-col> -->
            <!-- <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
              <div class="image-text height" @click="toRouterName('Transfuse')">
                <span class="title">输液监控系统</span>
                <span class="btn-text">了解更多</span>
              </div>
            </el-col> -->

            <!-- <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
              <div class="image-text height" @click="toRouterName('Tiwen')">
                <span class="title">体温采集系统</span>
                <span class="btn-text">了解更多</span>
              </div>
            </el-col> -->
            <!-- <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
              <div class="img-box height">
                <img src="@/assets/home/tiwen.png" class="images" alt="" />
              </div>
            </el-col> -->
            <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
              <div class="image-text height" @click="toRouterName('Baby')">
                <span class="title">婴儿防盗系统</span>
                <span class="btn-text">了解更多</span>
              </div>
            </el-col>
            <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
              <div class="img-box height">
                <img src="@/assets/home/yinger.png" class="images" alt="" />
              </div>
            </el-col>

            <!-- 2 -->
            <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
              <div class="img-box height">
                <img src="@/assets/home/fangzoushi.png" class="images" alt="" />
              </div>
            </el-col>
            <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
              <div class="image-text height" @click="toRouterName('beLost')">
                <span class="title">特殊患者防走失系统</span>
                <span class="btn-text">了解更多</span>
              </div>
            </el-col>
            <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
              <div class="img-box height">
                <img src="@/assets/home/zichan.png" class="images" alt="" />
              </div>
            </el-col>
            <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
              <div class="image-text height" @click="toRouterName('Assets')">
                <span class="title">医院资产定位系统</span>
                <span class="btn-text">了解更多</span>
              </div>
            </el-col>

            <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
              <div class="image-text height" @click="toRouterName('Ward')">
                <span class="title">智慧病房交互系统</span>
                <span class="btn-text">了解更多</span>
              </div>
            </el-col>
            <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
              <div class="img-box height">
                <img src="@/assets/home/bingfang.png" class="images" alt="" />
              </div>
            </el-col>
            <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
              <div class="image-text height" @click="toRouterName('Nurse')">
                <span class="title">移动护理信息系统</span>
                <span class="btn-text">了解更多</span>
              </div>
            </el-col>
            <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
              <div class="img-box height">
                <img src="@/assets/home/huli.png" class="images" alt="" />
              </div>
            </el-col>

            <!-- 3 -->
            <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
              <div class="img-box height">
                <img src="@/assets/home/lenglian.png" class="images" alt="" />
              </div>
            </el-col>
            <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
              <div class="image-text height" @click="toRouterName('coldChain')">
                <span class="title">院内冷链管理系统</span>
                <span class="btn-text">了解更多</span>
              </div>
            </el-col>
            <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
              <div class="img-box height">
                <img src="@/assets/home/nengxiao.png" class="images" alt="" />
              </div>
            </el-col>
            <el-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6">
              <div class="image-text height" @click="toRouterName('Device')">
                <span class="title">设备能效管理系统</span>
                <span class="btn-text">了解更多</span>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="zd-warp">
        <div class="w-flex">
          <span class="title">
            <span class="t-text">平台服务</span>
            <span class="t-bg"></span>
          </span>
          <div class="subText">Platform Services</div>
        </div>
        <div class="w-content">
          <div class="service-bg">
            <div class="title">我们为医院提供最专业的解决方案</div>
            <p>
              提供400-6000MHz全频段数分式天线系统，为客户提供全方位的网络解决方案。
            </p>
            <p>
              涵盖了WIFI网络、物联网产品、遥测网、定位网、楼宇智能网络等领域，
            </p>
            <p>
              为移动医疗业务和移动护理、移动查房等应用场景提供可靠的网络支持。
            </p>
            <p>
              在全国范围内设有售后服务人员，致力于为客户提供全心全意的服务。
            </p>
            <p>无论是在安装调试阶段还是日常使用过程中，</p>
            <p>我们都会及时响应客户的需求，并提供专业的技术支持和解决方案。</p>
            <p>我们致力于为客户提供更加稳定、高效和安全的网络环境。</p>
            <p>无论您身处何地，我们都将竭尽全力为您提供优质的产品和服务。</p>
            <span class="btn">全国服务热线：138 1335 9066</span>
          </div>
        </div>
      </div>
      <!-- 新闻资讯 -->
      <div class="zd-warp">
        <div class="w-flex">
          <span class="title">
            <span class="t-text">新闻资讯</span>
            <span class="t-bg"></span>
          </span>
          <div class="subText">News and information</div>
        </div>
        <div class="w-content w1100" v-if="newsList.length > 0">
          <el-row :gutter="10" class="news-warp">
            <el-col :span="6" v-for="(item,index) in newsList" :key="index" >
              <el-card :body-style="{ padding: '0px' }" >
                <img :src="item.indexImage !='' ? item.indexImage : newImages" class="image" @click="setRouter(item)"/>
                <div class="news-center" @click="setRouter(item)">
                  <div class="w-title">
                    {{item.title}}
                  </div>
                  <div class="w-text">
                    <span class="text">{{ textContent(item.context) }}</span>
                    <span class="time">发布时间：{{item.publishTime}}</span>
                  </div>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </div>
      </div>
      <!-- 介绍 -->
      <div class="zd-warp introduce">
        <div class="w1100 introduce-center">
          <img src="@/assets/home/info-top.png" alt="" />
          <div class="i-w-flex">
            <div class="flex-box">
              <span class="title"> 南京迪孚网络科技有限公司 </span>
              <span class="text">公司位于美丽城市南京的我们是一家专注于医疗无线网络和物联网开发的企业。多年来，我们致力于为医疗机构提供先进的解决方案，以提升医疗服务的效率和质量。目前，我们拥有多种产品，包括wifi无线网络解决方案、输液监控系统、无线体温采集系统、婴儿防盗系统、特殊患者防走失系统、医院资产定位系统、智慧病房交互系统、移动护理信息系统、院内冷链管理系统以及设备能效管理系统等。这些产品覆盖了医院的各个关键领域，为医院提供了全方位的支持和服务。</span>
              <a class="btn" href="/aboutUs">查看详情</a>
            </div>
            <img src="@/assets/home/info-img.png" alt="" class="images" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import banner from '@/components/banner'
import newImages from '@/assets/news/image.jpg'
import { getListByPage } from '@/api/api'
export default {
  name: "Home",
  components: {
    banner
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (vm.$route.params.source === "solution") {
        // const solutionH = vm.$refs.solution.offsetTop;
        // console.log("productH", solutionH);
        // window.scrollTo(0, solutionH - 100);
        // vm.$refs.product.scrollIntoView({ block: 'start', behavior: 'smooth' })
      }
    });
  },
  data() {
    return {
      autoHeight: "",
      marH: "",
      newsList: [],
      newImages: newImages
    };
  },
  mounted(){
    getListByPage({ page: 1, limit: 4, isShow: 1}).then(res => {
      this.newsList = res.data.list;
    })
  },
  methods: {
    setRouter(val) {
      this.$router.push({ name: 'newsDetails', params: { obj: val }})
    },
    textContent(htmlString) {
      var tempDiv = document.createElement('div');
      tempDiv.innerHTML = htmlString;
      var text = tempDiv.textContent || tempDiv.innerText || '';
      return text.trim();
    },
    // 通过 name 跳转页面
    toRouterName(val){
      this.$router.push({ name: val });
    }
  },
};
</script>
<style lang="scss" scoped>
.zd-warp {
  margin-top: 50px;
  display: flex;
  justify-content: center;
  flex-direction: column;

  .w-flex {
    .title {
      font-size: 30px;
      position: relative;

      .t-text {
        position: relative;
        z-index: 11;
      }

      .t-bg {
        position: absolute;
        left: -65px;
        right: -65px;
        bottom: 0;
        height: 12px;
        background: #c0dbff;
      }
    }

    .subText {
      font-size: 18px;
      color: #afafaf;
    }
  }
  .w1100 {
    margin: 0 auto;
    width: 1100px;
  }
  .w-content {
    margin-top: 50px;
    .height {
      height: 267.5px;
      margin-top: 10px;
      overflow: hidden;
    }
    .img-box .images {
      width: 100%;
      transition: transform 1s ease; /* 添加过渡效果 */
    }
    .images:hover{
      transform: scale(1.5); /* 放大 */
    }
    .image-text {
      color: #fff;
      background: #3488fa;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .title {
        margin-bottom: 20px;
        font-weight: 600;
        font-size: 20px;
      }
      .btn-text {
        width: 100px;
        font-size: 18px;
        color: #fff;
        background: #3488fa;
        align-self: center;
        padding: 6px 20px;
        border: 1px solid #fff;
        cursor: pointer;
      }
    }
    // 平台服务
    .service-bg {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      background: url("../../assets/home/serviceBg.png") no-repeat;
      background-size: 100% 100%;
      padding: 50px 0;
      color: #fff;
      .title {
        font-size: 25px;
        margin-bottom: 20px;
      }
      p {
        font-size: 14px;
        padding: 5px 0;
      }
      .btn {
        width: 300px;
        padding: 8px;
        font-size: 20px;
        margin-top: 15px;
        border-radius: 20px;
        align-self: center;
        background: #5352b6;
      }
    }
    // 新闻
    .news-warp {
      margin-bottom: 20px;
      cursor: pointer;
      .image {
        width: 100%;
        height: 268px;
      }
      .news-center {
        padding: 8px;
        display: flex;
        justify-content: flex-start;
        flex-direction: column;
        text-align: left;
        .w-title {
          max-height: 50px;
          font-size: 20px;
          // font-weight: 600;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          position: relative;
          // &::after {
          //   content: "...";
          //   position: absolute;
          //   bottom: 0;
          //   right: 0;
          //   padding-right: 95px;
          //   padding-left: 4px;
          //   background: linear-gradient(to right, transparent, #fff 0%);
          // }
        }
        .w-text {
          margin-top: 8px;
          font-size: 14px;
          color: #666;
          .text {
            height: 55px;
            display: block;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
          }
          .time {
            display: block;
            margin-top: 10px;
          }
        }
      }
    }
  }
}
// 介绍
.introduce {
  width: 100%;
  background: #3488fa;
  padding: 20px 0;
  margin-bottom: 60px;
  .introduce-center {
    text-align: left;
    .i-w-flex {
      margin-top: 10px;
      display: flex;
      align-items: self-start;
      .flex-box {
        width: 50%;
        color: #fff;
        padding: 0 10px;
        box-sizing: border-box;
        .title {
          width: 100%;
          display: block;
          font-weight: 600;
          font-size: 30px;
          text-align: left;
        }
        .text {
          margin-top: 5px;
          // letter-spacing: 3px;
          font-size: 16px;
          line-height: 2;
          text-align: justify;
          color: #fff;
        }
        .btn{
          margin-top: 20px;
          display: block;
          width: 100px;
          font-size: 18px;
          color: #fff;
          background: #3488fa;
          text-align: center;
          padding: 6px 20px;
          border: 1px solid #fff;
          cursor: pointer;
        }
      }
      .images {
        width: 50%;
      }
    }
  }
}
</style>
